import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-tela-conteudo" }
const _hoisted_5 = { class: "ss-card ss-card-space ss-tela-conteudo-completo ss-alinhar-texto-esquerda" }
const _hoisted_6 = {
  key: 0,
  class: "ss-card ss-card-space"
}
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESAS")
], -1)
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_10 = { class: "ant-table-column-title" }
const _hoisted_11 = { class: "ant-table-column-sorter ant-table-column-sorter-full" }
const _hoisted_12 = { class: "ant-table-column-sorter-inner ant-table-column-sorter-inner-full" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "Ordenar crescente",
  class: "anticon anticon-caret-up ant-table-column-sorter-up"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "caret-up",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" })
  ])
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "caret-down",
  class: "anticon anticon-caret-down ant-table-column-sorter-down"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "caret-down",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" })
  ])
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 3,
  class: "acoes-item"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 4 }
const _hoisted_25 = { key: 5 }
const _hoisted_26 = {
  class: "ant-row",
  style: {"padding":"10px"}
}
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_29 = { class: "ant-input-affix-wrapper ss-paginacao-qtde-registros" }
const _hoisted_30 = { class: "ant-input-suffix" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "Limite total de registros. Lembre-se: Quanto menor a quantidade de registros mais rápido o seu resultado será apresentado.", -1)
const _hoisted_32 = {
  tabindex: "-1",
  role: "img",
  "aria-label": "info-circle",
  class: "anticon anticon-info-circle",
  style: {"color":"rgba(0, 0, 0, 0.45)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_busca_avancada = _resolveComponent("busca-avancada")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_preferencias_coluna = _resolveComponent("preferencias-coluna")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_icone = _resolveComponent("icone")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: _ctx.props.estrutura.identificadorRecurso,
          tituloRecurso: _ctx.props.estrutura.titulo,
          exibirAtalhosTela: true,
          exibirHistoricoTela: true,
          empresasSelecionadas: _ctx.telaBase.empresasSelecionadas,
          "onUpdate:empresasSelecionadas": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
        }, {
          BotoesAcoes: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-primary ss-btn-acao-destaque",
              style: {"margin-right":"10px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.props.estrutura.botaoPrincipalAcao), 1)
            ])
          ]),
          _: 1
        }, 8, ["identificadorRecurso", "tituloRecurso", "empresasSelecionadas"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.telaBase.apresentarEmpresas)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_a_select, {
                        value: _ctx.telaBase.empresasSelecionadas,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event)),
                        mode: "multiple",
                        style: {"width":"100%"},
                        optionFilterProp: "label",
                        onChange: _ctx.atualizarSelecaoEmpresas,
                        allowClear: true,
                        options: _ctx.telaBase.empresasDisponiveis
                      }, null, 8, ["value", "onChange", "options"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_collapse, {
              ghost: "",
              class: "ss-accordion"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_panel, {
                  key: "1",
                  header: "BUSCA AVANÇADA"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_busca_avancada, {
                      buscaAvancada: _ctx.tela.buscaAvancada,
                      "onUpdate:buscaAvancada": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tela.buscaAvancada) = $event)),
                      visivel: _ctx.tela.exibirBuscaAvancada,
                      "onUpdate:visivel": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tela.exibirBuscaAvancada) = $event)),
                      empresas: _ctx.telaBase.empresasSelecionadas,
                      onAplicarFiltros: _ctx.aplicarFiltros
                    }, null, 8, ["buscaAvancada", "visivel", "empresas", "onAplicarFiltros"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_preferencias_coluna, {
              colunas: _ctx.tela.colunas,
              "onUpdate:colunas": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tela.colunas) = $event)),
              visivel: _ctx.tela.exibirPersonalizarColunas,
              "onUpdate:visivel": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tela.exibirPersonalizarColunas) = $event))
            }, null, 8, ["colunas", "visivel"]),
            _createVNode(_component_card, { titulo: "REGISTROS" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  columns: _ctx.tela.colunas.filter(item => item.visible),
                  "data-source": _ctx.tela.dados,
                  rowKey: "codigo",
                  pagination: false,
                  loading: _ctx.telaBase.carregando,
                  scroll: { x: _ctx.tela.windowWidth , y: _ctx.tela.windowHeight},
                  "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.onSelectChange },
                  size: "small"
                }, {
                  headerCell: _withCtx(({ column }) => [
                    (column.ordering)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: column.key,
                          class: "ss-coluna-ordenada"
                        }, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(column.title), 1),
                          _createElementVNode("span", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              (_openBlock(), _createElementBlock("a", {
                                title: "Ordenação crescente",
                                key: 'ord-asc' + column.key,
                                class: _normalizeClass([_ctx.ordenacaoAtiva(column.key,'ASC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                                onClick: ($event: any) => (_ctx.ordenarDados(column.key,'ASC'))
                              }, _hoisted_15, 10, _hoisted_13)),
                              (_openBlock(), _createElementBlock("a", {
                                title: "Ordenação decrescente",
                                key: 'ord-desc' + column.key,
                                class: _normalizeClass([_ctx.ordenacaoAtiva(column.key,'DESC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                                onClick: ($event: any) => (_ctx.ordenarDados(column.key,'DESC'))
                              }, _hoisted_18, 10, _hoisted_16))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  bodyCell: _withCtx(({ column, record, text }) => [
                    (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.editarModal(record.codigo))
                        }, [
                          _createElementVNode("span", null, _toDisplayString(text), 1)
                        ], 8, _hoisted_19))
                      : (column.customRenderRow === _ctx.ECustomRenderRow.TagAtivo)
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 1,
                            class: _normalizeClass(record.ativo === false ? 'ss-tag-vermelho' : 'ss-tag-verde')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(record.ativo === true ? 'Ativo' : 'Inativo'), 1)
                            ]),
                            _: 2
                          }, 1032, ["class"]))
                        : (column.customRenderRow === _ctx.ECustomRenderRow.TagAtiva)
                          ? (_openBlock(), _createBlock(_component_a_tag, {
                              key: 2,
                              class: _normalizeClass(record.ativo === false ? 'ss-tag-vermelho' : 'ss-tag-verde')
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(record.ativo === true ? 'Ativa' : 'Inativa'), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"]))
                          : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("a", {
                                  class: "visualizar",
                                  onClick: ($event: any) => (_ctx.editarModal(record.codigo))
                                }, [
                                  _createVNode(_component_icone, { nome: "visualizar" })
                                ], 8, _hoisted_21),
                                (_ctx.telaBase.permissaoDados.imprimir)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "imprimir",
                                      onClick: ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF, record.codigo))
                                    }, [
                                      _createVNode(_component_icone, { nome: "imprimir" })
                                    ], 8, _hoisted_22))
                                  : _createCommentVNode("", true),
                                (_ctx.telaBase.permissaoDados.excluir)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      onClick: ($event: any) => (_ctx.confirmaExclusao(record)),
                                      class: "excluir"
                                    }, [
                                      _createVNode(_component_icone, { nome: "excluir" })
                                    ], 8, _hoisted_23))
                                  : _createCommentVNode("", true)
                              ]))
                            : (column.customRenderRow === _ctx.ECustomRenderRow.MascararCPFCNPJ)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(text)), 1))
                              : (column.customRenderRow === _ctx.ECustomRenderRow.MascararTelefoneCelular)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.UtilitarioMascara.mascararTelefoneFixoOuCelular(text)), 1))
                                : _createCommentVNode("", true)
                  ]),
                  emptyText: _withCtx(() => [
                    _createVNode(_component_mensagem_sem_dados, {
                      resultadoPesquisa: !_ctx.telaBase.carregando,
                      mensagem: _ctx.telaBase.carregando?'Buscando informações, por favor aguarde...':'Nenhum registro foi encontrado com estes filtros!'
                    }, null, 8, ["resultadoPesquisa", "mensagem"])
                  ]),
                  _: 1
                }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_a_pagination, {
                  class: "ss-paginacao-completa",
                  current: _ctx.tela.paginacao.current,
                  "onUpdate:current": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tela.paginacao.current) = $event)),
                  size: "small",
                  total: _ctx.tela.paginacaoApi.totalRegistros,
                  "show-total": (total, range) => `${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[0])} - ${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[1])} de ${_ctx.UtilitarioMascara.mascararNumeroInteiro(total)} registros`,
                  "page-size": _ctx.tela.paginacao.pageSize,
                  pageSizeOptions: _ctx.tela.paginacao.pageSizeOptions,
                  onShowSizeChange: _ctx.onShowSizeChange,
                  onChange: _ctx.onPageChange
                }, null, 8, ["current", "total", "show-total", "page-size", "pageSizeOptions", "onShowSizeChange", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("span", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tela.totalRegistrosComMascara) = $event)),
                    onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.alterarQuantidadeRegistroTotal($event))),
                    placeholder: "Total registros",
                    type: "text",
                    class: "ant-input hidden"
                  }, null, 544), [
                    [_vModelText, _ctx.tela.totalRegistrosComMascara],
                    [_directive_maska, _ctx.UtilitarioMascara.formatoMascaraNumeroInteiro]
                  ]),
                  _createElementVNode("span", _hoisted_30, [
                    _createVNode(_component_a_tooltip, { placement: "top" }, {
                      title: _withCtx(() => [
                        _hoisted_31
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_32, [
                          _createVNode(_component_icone, { nome: "informacoes" })
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "CrudModal")
  ]))
}